export enum TagValues {
  COST_OF_CARE = "Cost of Care",
  EFFICIENCY_OF_CARE = "Efficiency of Care",
  PIN_VALIDATION = "PIN Validation",
  QUALITY_OF_CARE = "Quality of Care",
  RECONSIDERATION = "Reconsideration",
  SPECIALTY_AND_ADDRESS_UPDATES = "Specialty and Address Updates",
  TECHNICAL_ISSUE = "Technical Issue",
  TIERED_BENEFITS = "Tiered Benefits",
  OTHER = "Other",
}
